import { PhoneNumberInput } from 'browser/components/atomic-elements/atoms/input/phone-number-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const PhoneNumberField = LabelFieldFactory({ InputComponent: PhoneNumberInput })
export {PhoneNumberField}
